import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PricePerMeter from '../Utils/PricePerMeter/PricePerMeter.jsx';
import styles from './RealEstatePreview.less';
import { getCommercializationType } from '../../realEstateTypes.js';
import config from './config.js';
import WidgetTitle from '../Utils/Widget/Title/Title.jsx';

class CosmaRealEstatePreviewDesktopAndTablet extends Component {
  render() {
    const { realEstateType, currentStat, priceTrend, onClickHandler, locationName } = this.props;
    const titleCosmaConfig = config.getForCosma(realEstateType);
    const titleConfig = config.getFor(realEstateType);
    return (
      <div className="grid-item">
        <WidgetTitle className="align-left" id="realEstatePreview" boldText={false} lineHeight={1.5}>
          Sie interessieren sich für <b>{titleCosmaConfig.title}</b> <br />
          {` ${titleCosmaConfig.realEstateType}`} im Wohnumfeld der Adresse {locationName}
        </WidgetTitle>
        <div
          className={`grid-item grid-flex gutter grid-justify-center padding-top-xl ${styles.previewItemContainer}`}
        >
          <div className={`grid-item margin-right-xl ${styles.previewItemCosmaBorder}`}>
            <div className="align-left">
              <PricePerMeter
                appearance="cosma-bold"
                price={currentStat.price}
                color="font-regular"
                commercializationType={getCommercializationType(realEstateType)}
              />
              <p className="font-lightgray font-xs">
                {titleCosmaConfig.priceSubTitle} Q{currentStat.quarter} {currentStat.year}
              </p>
            </div>
          </div>

          <div className={`grid-item margin-right-xl ${styles.previewItemCosmaBorder}`}>
            <div className="vertical-center-container horizontal-center align-left ">
              <span className={`${styles.previewItemStat} font-regular font-m`} id="price-change-percentage">
                {priceTrend.sign}
                {priceTrend.priceChangeInPercent}&#37;
              </span>
              <div className="font-lightgray font-xs">
                <p id="price-subtitle">{titleConfig.priceTrendSubTitle}</p>
                <p id="price-quarter">
                  {' '}
                  zu Q{priceTrend.quarter} {priceTrend.year}
                </p>
              </div>
            </div>
          </div>

          <div className="grid-item palm-hide margin-left-xl lap-hide margin-top-xl">
            <button type="button" className="button-secondary" onClick={onClickHandler}>
              Mehr erfahren
            </button>
          </div>
        </div>
      </div>
    );
  }
}

CosmaRealEstatePreviewDesktopAndTablet.propType = {
  realEstateType: PropTypes.string.isRequired,
  currentStat: PropTypes.objectOf(
    PropTypes.shape({
      year: PropTypes.number.isRequired,
      quarter: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  priceTrend: PropTypes.objectOf(
    PropTypes.shape({
      sign: PropTypes.string.isRequired,
      priceChangeInPercent: PropTypes.number.isRequired,
      year: PropTypes.number.isRequired,
      quarter: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  locationName: PropTypes.string.isRequired,
};

export default CosmaRealEstatePreviewDesktopAndTablet;
